import { REQUEST_WIDGET } from '../constants/PostMessageTypes';
import { postMessageToParent } from './postMessageToParent';
export const handleRequestWidget = () => postMessageToParent(REQUEST_WIDGET);